export default __webpack_public_path__ + "static/flowers-8a0ba3f4525b77d11693ca183d4111dc.png";